/* import __COLOCATED_TEMPLATE__ from './product-list-item.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type Intl from 'ember-intl/services/intl';
import { ProductRow } from '../services/state';

const GIGA = 1000000000,
  MEGA = 1000000,
  KILO = 1000;

interface ProductListItemSignature {
  Args: {
    productItem: ProductRow;
    selectedItem: string;
  };
}
export default class ProductListItem extends Component<ProductListItemSignature> {
  @service declare intl: Intl;
  get sampleRateValue() {
    const masterFclk = this.args.productItem.masterFclk;
    let result = masterFclk.toString();
    if (masterFclk >= GIGA) {
      result = (masterFclk / GIGA).toString();
    } else if (masterFclk >= MEGA) {
      result = (masterFclk / MEGA).toString();
    } else if (masterFclk >= KILO) {
      result = (masterFclk / KILO).toString();
    }

    return result;
  }
  get sampleRateUnit() {
    const masterFclk = this.args.productItem.masterFclk;
    let result = 'SPS';
    if (masterFclk >= GIGA) {
      result = 'GSPS';
    } else if (masterFclk >= MEGA) {
      result = 'MSPS';
    } else if (masterFclk >= KILO) {
      result = 'kSPS';
    }

    return result;
  }
  get display() {
    return this.intl.t('dds.device_dropdown_entry_text', {
      device: this.args.productItem.name,
      samplerate: this.sampleRateValue,
      units: this.sampleRateUnit,
      width: this.args.productItem.resolution,
    });
  }
  get value() {
    return this.args.productItem.name;
  }
  get selected() {
    return this.args.productItem.name === this.args.selectedItem;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    ProductListItem: typeof ProductListItem;
  }
}
